import { useContext } from 'react';
import { Link } from 'react-router-dom';
import Button from '@classify/react-core-components/Button';
import { translate } from '@openclassrooms/translations';
import { ROUTES } from '@openclassrooms/routing';
import CourseContext from '../../contexts/courseContext';
import FollowCourseButton from '../FollowCourseButton';

function StartNowButton() {
  const { course, currentUser } = useContext(CourseContext);
  const { categoryColor } = course;

  if (!currentUser) {
    const targetPathQueryParam = new URLSearchParams({
      _target_path: course.OpenClassroomsUrl!,
      context: 'courseAccess',
    });

    return (
      <Button
        component={Link}
        to={`${ROUTES.AUTH.LOGIN}?${targetPathQueryParam}`}
        role="link"
        style={{ background: categoryColor }}
      >
        {translate('course.start.button')}
      </Button>
    );
  }

  return <FollowCourseButton>{translate('course.start.button')}</FollowCourseButton>;
}

export default StartNowButton;
